import useCheckout from '../composables/useCheckout'
import useShipping from '../composables/useShipping'
// import useBilling from '../composables/useBilling'
import router from '../router'

export default function useProgress() {
  const { addresses, info: checkoutInfo } = useCheckout()

  /*
        Each time the router changes, it will look for a match on the route name.
        If there is a match and a validation function exists, it will run it.
        If the validation function fails, the onError function will be called.

        The progress bar uses the array index of steps and uses steps in the array after
        the current step should be inaccessible so all steps in the progress bar should be
        listed here even if they do not have validation requirements.
    */
  const steps = []

  //These steps are not available for quote checkout
  if (!checkoutInfo.value.isQuote) {
    steps.push({
      name: 'Cart',
      label: 989, // Label: Cart
    })
    steps.push({
      name: 'Ship Address',
      label: 990, // Label: Shipping Address
    })
    steps.push({
      name: 'Ship Method',
      validation: () => readyForShippingMethods(),
      onError: () => router.push({ name: 'Ship Address' }),
      label: 991, // Label: Shipping Method
    })
  }

  steps.push({
    name: 'Billing',
    onComplete: () => { console.log('PUSH TO BILLING') },
    validation: () => readyForBilling(),
    onError: () => router.push({ name: 'Ship Method' }),
    label: 992, // Label: Payment
  })

  steps.push({
    name: 'Review',
    validation: () => readyForReview(),
    onError: () => router.push({ name: 'Billing' }),
    label: 993, // Label: Review
  })

  steps.push({
    name: 'Complete',
    validation: () => hasProcessedOrder(),
    onError: () => router.push({ name: 'Review' }),
  })

  steps.push({
    name: 'Edit Cart Item',
  })

  const getStepIndex = (name) => {
    return steps.findIndex((step) => step.name == name)
  }

  const checkAndPreventProgress = (route) => {
    var selectedStep = steps.find((step) => step.name == route.name)
    console.log('STEPS: ', selectedStep)
    // console.log('Step Validation: ', selectedStep.validation())
    //if selectedStep not defined (or if order is complete and we try and hit another step) we should redirect back to cart or quote
    if (!selectedStep || (selectedStep.name != 'Complete' && hasProcessedOrder())) {
      backToStart()
      return false
    } else if (selectedStep.validation && !selectedStep.validation()) {
      selectedStep.onError()
      return false
    }
    return true
  }

  const readyForShippingMethods = () => {
    return addresses.value.shipping.VALID
  }

  const readyForBilling = () => {
    const { shippingSet } = useShipping()

    //quote checkout starts on billing step
    return shippingSet.value || checkoutInfo.value.isQuote
  }

  const readyForReview = () => {
    // const { method, cardErrors, poErrors, cardDataComplete } = useBilling()
    // console.log(
    //   'method.value',
    //   method.value,
    //   'cardErrors.value',
    //   cardErrors.value,
    //   'cardDataComplete()',
    //   cardDataComplete()
    // )
    return (
      // (method.value == 'payCreditCard' && cardErrors.value.length == 0 && cardDataComplete()) ||
      // (method.value == 'payCreditCard' && cardErrors.value.length == 0 && cardDataComplete()) ||
      // (method.value == 'payPO' && poErrors.value.length == 0)
        true
    )
  }

  const hasProcessedOrder = () => {
    const { orderProcessed } = useCheckout()
    return orderProcessed.value.orderId !== undefined
  }

  const getStepClass = (step, route) => {
    var checkStep = getStepIndex(step.name)
    var currStep = getStepIndex(route)

    var _class = '' //Class to return for DOM

    if (checkStep == currStep) {
      _class = 'current'
    } else {
      _class = checkStep > currStep ? 'pending' : 'complete'
    }

    if (steps.length - 1 == checkStep) {
      _class += ' last'
    }

    if (!step.label) {
      _class += ' hide'
    }

    return _class
  }

  const isStepDisabled = (step, route) => {
    var checkStep = getStepIndex(step.name)
    var currStep = getStepIndex(route)

    return checkStep > currStep || route === 'Complete' ? true : false
  }

  const getStep = (step, route) => {
    return {
      class: getStepClass(step, route),
      disabled: isStepDisabled(step, route),
    }
  }

  const backToStart = () => {
    if (checkoutInfo.value.isQuote) {
      window.location.href = '/quote?q=' + checkoutInfo.value.quoteHash
    } else {
      //refresh page to the cart
      window.location.href = '/cart'
    }
  }

  return {
    checkAndPreventProgress,
    getStep,
    steps,
  }
}
